import styled from 'styled-components';
import { themeColor, themeSize, themeZIndex } from '../../../theme/getters';
import { slideFromDownTransition } from '../../../theme/transitions';

export const AnimationContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: ${themeZIndex('overlay')};
  text-align: center;
  will-change: transform;
  background-color: ${themeColor('secondaryBlue')};
  ${slideFromDownTransition};
`;

export const ScrollContainer = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: ${themeSize('header')}px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;
